export default __webpack_public_path__ + "static/media/slide-away.d22343fa.png";